import { useCallback } from 'react'
import { path } from 'ramda'

import { POST_SALE_TYPE, convertResult, convertParams } from 'app/common/api/requests/food/items/sale_types/post'
import { CreateParams, SaleType } from 'app/dataTypes/dishes/saleType'
import { api } from 'app/api'
import useCallbackRef from 'app/common/hooks/useCallbackRef'


export function useCreateSaleType(onSuccess?: (saleType: SaleType) => void) {
  const onSuccessRef = useCallbackRef(onSuccess)

  const handleCreateSaleType = useCallback(async (params: CreateParams) => {
    const res = await api.request(POST_SALE_TYPE, {
      error: (error) => {
        const dataMessage = path(['response', 'data', 'message'], error)
        if (dataMessage === 'title is already taken') {
          return 'Такой тип продукции уже существует'
        }
        return 'Не удалось добавить новый тип продукции'
      },
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    })

    if (res) {
      onSuccessRef.current?.(res)
    }

    return res
  }, [onSuccessRef])

  return handleCreateSaleType
}
